import { AnchorHTMLAttributes } from 'react';
import { joinClassNames } from '../../utils';
import styles from './TextLink.module.scss';

export type TextLinkProps = Omit<AnchorHTMLAttributes<HTMLAnchorElement>, 'onClick'> & {
  external?: boolean;
};

export const TextLink = ({ children = null, href, external = false, className, ...props }: TextLinkProps) => {
  const classNames = joinClassNames(styles.textLink, className);
  const target = external ? '_blank' : '_parent';

  return (
    <a className={classNames} href={href} target={target} {...props}>
      {children}
    </a>
  );
};
